import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Table,
} from "antd";
import React, { useState } from "react";
import FilterContainer from "../../../../../components/common/FilterContainer";
import MultiSelect from "../../../../../components/common/MultiSelect";
import PageHeading from "../../../../../components/common/PageHeading";
import RightBar from "../../../../../components/common/RightBar";
import { property, tableColumns, tableData,ManuallyPostBillRightBar } from "./ManuallyPostBillData";

const ManuallyPostBills = () => {
  const [units, setUnits] = useState([]);
  const onChange = (value) => {
    const findData = property.find((item) => item.value === value);
    setUnits(findData.units);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  return (
    <div>
      <PageHeading heading="Manually Post Recurring Bills" />
      <Row>
        <Col span={24}>
          <FilterContainer
            heading={
              "Filter recurring bills by using any of the search filters below."
            }
          >
            <Form
              name="basic"
              labelCol={{
                span: 6,
              }}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              autoComplete="off"
              colon={false}
            >
              <Row>
                <Col span={24}>
                  <Form.Item label="Properties">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Search by property, group, or portfolio"
                      optionFilterProp="children"
                      onChange={onChange}
                      onSearch={onSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={property}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Units">
                    <MultiSelect
                      options={units}
                      placeholder="Search by unit"
                      disabled={units.length > 0 ? false : true}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Payee">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Start typing to search"
                      optionFilterProp="children"
                      onChange={onChange}
                      onSearch={onSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        {
                          value:
                            "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                          label:
                            "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                        },
                        {
                          value:
                            "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
                          label:
                            "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
                        },
                        {
                          value: "AT&T - PO Box 5014  Carol Stream, IL 60197",
                          label: "AT&T - PO Box 5014  Carol Stream, IL 60197",
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Post Code">
                    <Input style={{ width: "30%" }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label=" ">
                    <Checkbox onChange={onChange}>
                      Include Automatically Recurring Bills
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label=" ">
                    <Button type="primary" htmlType="submit">
                      Search
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </FilterContainer>
        </Col>
      </Row>
      <p style={{ textAlign: "center" }}>
        Your search resulted in 2 bills. Click Post Bills to post them to the
        system.
      </p>
      <br />
      <Row justify="space-between">
        <Col span={6}>
          <Button type="primary">Post Bills</Button>
          <Button style={{ marginLeft: "10px" }}>Cancel</Button>
        </Col>
        <Col span={6}>
          <Form.Item label="Post Date">
            <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
      <Table columns={tableColumns} dataSource={tableData} size="small" />
      <div className="RightSidebar">
        <RightBar RightBarData={ManuallyPostBillRightBar} />
      </div>
    </div>
  );
};

export default ManuallyPostBills;
